/**
 * @generated SignedSource<<03111e8bc1199410984e5651dfb6103d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImageCarouselRefetch_viewer$data = {
  readonly photos?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_photos">;
  } | null> | null;
  readonly " $fragmentType": "ProductImageCarouselRefetch_viewer";
};
export type ProductImageCarouselRefetch_viewer$key = {
  readonly " $data"?: ProductImageCarouselRefetch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarouselRefetch_viewer">;
};

import ProductImageCarouselRefetchQuery_graphql from './ProductImageCarouselRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchPhotos"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": ProductImageCarouselRefetchQuery_graphql
    }
  },
  "name": "ProductImageCarouselRefetch_viewer",
  "selections": [
    {
      "condition": "fetchPhotos",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "ItemPhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductCarouselItem_photos"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "da41128a7beb292e1c821e705541b6e5";

export default node;
